import { IsNotEmpty, IsUUID } from 'class-validator';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

import { UploadDocumentBatchElement } from './upload-document-batch-element';

export class UploadDocumentBatchDto {
  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  eventId: string;

  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  nodeId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  documents: UploadDocumentBatchElement[];

  attributes?: FormAttributesRequest;
}
